module.exports = __webpack_public_path__ + "resources/img/img_criminal_ip_for_asm2_jp.631f20878bffcf7626e6486a762c43b2.png";